<div class="badge">
    {{ badgeText }}
</div>